<template>
  <OModal v-model="isActive"
    class="ow-popup"
    >
    <div class="ow-popup-card">
      <div class="ow-popup-header">
        <slot name="popupHeaderLeft"></slot>
        <img src="/images/OxiaLogoAllWhite.png" alt="Icon" class="ow-popup-header-logo">
        <button v-if="isCloseable" class="os-modal-close ow-popup-close os-icon icon-x" @click="closePopup"></button>
      </div>
      <div class="ow-popup-body-wrapper">
        <div class="ow-popup-body" :class="popupBodyClass">
          <slot></slot>
        </div>
        <div v-if="hasFooterSlot" class="ow-popup-footer">
          <slot name="popupFooterSlot"></slot>
        </div>
      </div>
    </div>
  </OModal>
</template>

<script setup lang="ts">
interface IWebsitePopup {
  isCloseable?: boolean
  hasFooterSlot?: boolean
  popupBodyClass?: string
}

const props = defineProps<IWebsitePopup>();

const isActive = defineModel({ default: false, type: Boolean });

const emit = defineEmits(['closeButtonClicked']);

const closePopup = () => {
  emit('closeButtonClicked');
};
</script>

<style lang='scss'>
.ow-popup {
  & .os-modal-body {
    // height: auto !important;
    & .ow-popup-card {
      height: fit-content;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      // border: 3px solid #fff;
      padding: 2px;
      border-radius: 10px;
      overflow: hidden;
      box-sizing: border-box;
      width: 100%;
      flex: 1 1 100%;
      & .ow-popup-header {
        width: 100%;
        flex: 0 0 50px;
        background-color: #104670;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 7px 7px 0 0;
        box-shadow: 0px 0px 5px -2px #104670;
        & .ow-popup-header-logo {
          height: 40px;
        }
        & .ow-popup-close {
          position: absolute;
          right: 5px;
          top: 10px;
          background-color: #fff;
          width: 30px;
          height: 30px;
          transition: transform ease 0.2s, background-color ease 0.2s;
          &:hover {
            transform: scale(1.2);
            background-color: #d61f38;
          }
        }
      }
      & .ow-popup-body-wrapper {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        border: 2px solid #104670;
        box-shadow: 0px 0px 5px -2px #104670;
        border-top: none;
        border-radius: 0 0 7px 7px;
        & .ow-popup-body {
          width: 100%;
          padding: 20px;
          flex: 1 1 calc(100% - 60px);
          box-sizing: border-box;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          position: relative;
          &.overflow-hidden {
            overflow: hidden;
          }
          &::-webkit-scrollbar {
            width: 12px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: #0d395b;
            border-radius: 15px;
            border-radius: 50px;
            border: 2px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
          }
        }
        & .ow-popup-footer {
          width: 100%;
          flex: 60px;
        }
      }
    }
  }

}
</style>
